// apolo/src/lib/globMatch.js — harness-uplift-r2 (shared glob primitive).
// @arch:pure-engine
//
// Extracted from steeringScope so both steeringScope AND context/ruleActivation
// can share it WITHOUT an import cycle (Dependency Rule / acyclic modules).
// Minimal glob: `**` crosses directories, `*` within a segment. Case-insensitive.

export function matchesGlob(filePath, glob) {
  const path = String(filePath ?? '').replace(/\\/g, '/').replace(/^\.\//, '');
  const pattern = String(glob ?? '').replace(/\\/g, '/').replace(/^\.\//, '');
  if (!path || !pattern) return false;
  const rx = pattern
    .replace(/[.+^${}()|[\]]/g, '\\$&')
    .replace(/\*\*\//g, '§ANYDIR§')
    .replace(/\*\*/g, '§ANY§')
    .replace(/\*/g, '[^/]*')
    .replace(/§ANYDIR§/g, '(?:[^/]+/)*')
    .replace(/§ANY§/g, '.*');
  return new RegExp(`(?:^|/)${rx}$`, 'i').test(path);
}
